module.exports = __webpack_public_path__ + "static/media/folder-open.6afd6713.svg";